import { observer } from "mobx-react";
import { Box } from "@mui/material";
import ContentBlock from "../components/ContentBlock";
import CalendarComponent from "../components/calendar/Calendar";
import { useEffect, useState } from "react";
import { useStoreContext } from "..";
import InfoText from "../components/typographies/InfoText";
import { useTranslation } from "react-i18next";

const Calendar = observer(() => {
  const { t } = useTranslation();
  const [events, setEvents] = useState<any[]>([]);
  const { calendarStore } = useStoreContext();

  useEffect(() => {
    const fetchCalendarEvents = async () => {
      if (!calendarStore.calendarEvents) {
        await calendarStore.getCalendarEvents();
      }
      const events = calendarStore.calendarEvents;
      if (events) {
        setEvents(events);
      }
    };
    fetchCalendarEvents();
  }, []);

  if (!events) {
    return null;
  }

  return (
    <Box className="page-container">
      <Box sx={{ marginBottom: 2 }}>
        <InfoText text={t("calendar.info")} />
      </Box>
      <ContentBlock>
        <CalendarComponent events={events} />
      </ContentBlock>
    </Box>
  );
});

export default Calendar;
